"use strict";

exports.__esModule = true;
exports.UhOh = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _LoggerContext = require("../LoggerContext");
var _styles = require("./styles");
var _dec, _class, _UhOh;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Display sanitized information about an error.
 */
var UhOh = exports.UhOh = (_dec = _LoggerContext.LoggerContext.withContext, _dec(_class = (_UhOh = /*#__PURE__*/function (_Component) {
  function UhOh() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleReloadClick = function () {
      var onReload = _this.props.onReload;
      onReload();
    };
    return _this;
  }
  _inheritsLoose(UhOh, _Component);
  var _proto = UhOh.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      logger = _this$props.logger,
      error = _this$props.error;
    if (logger != null) {
      logger.logError(error);
    } else {
      console.error(error);
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
      logger = _this$props2.logger,
      error = _this$props2.error;
    if (this.props.error !== prevProps.error) {
      if (logger != null) {
        logger.logError(error);
      } else {
        console.error(error);
      }
    }
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      error = _this$props3.error,
      title = _this$props3.title,
      description = _this$props3.description,
      _this$props3$shouldDi = _this$props3.shouldDisplayError,
      shouldDisplayError = _this$props3$shouldDi === void 0 ? true : _this$props3$shouldDi;
    return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
      "data-testid": "UhOh.title",
      title: title || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "UhOh.title",
        defaultMessage: "Something went wrong"
      }),
      visual: "warning-sign",
      description: description || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "UhOh.description",
        defaultMessage: "The problem has been automatically reported, click Reload to try again."
      }),
      action: /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.REFRESH,
        large: true,
        onClick: this.handleReloadClick,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "UhOh.reload",
          defaultMessage: "Reload"
        })
      })
    }, shouldDisplayError ? /*#__PURE__*/_react["default"].createElement(_styles.ErrorText, {
      "data-testid": "UhOh.errorText",
      block: true,
      muted: true
    }, /*#__PURE__*/_react["default"].createElement("strong", null, error.name), " ", /*#__PURE__*/_react["default"].createElement("em", null, error.message)) : false);
  };
  return UhOh;
}(_react.Component), _UhOh.defaultProps = {
  onReload: function onReload() {
    return document.location.reload();
  }
}, _UhOh)) || _class);